@import "../../generic-subcomponents/generic-card-container/generic-card-container";
@import "../../generic-subcomponents/generic-card-title/generic-card-title";
@import "../../generic-subcomponents/generic-card-labels/generic-card-labels";

.result-card__content {
  flex-direction: column;
}

se-divider {
  margin: 24px 0;
}

se-icon {
  vertical-align: middle;
}

.download-panel {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  &-only-download {
    display: flex;
    flex-direction: row-reverse;
  }

  qds-button {
    width: 100%;

    @media (min-width: $uiaas-tablet) {
      width: auto;
    }
  }
}

se-dialog {
  cursor: auto;
}

.document-card-more-languages {
  cursor: pointer;
  padding: 8px 7px;
  margin-inline-start: 4px;
  border-radius: 50%;
  color: #626469;
  background: #f3f2f2;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

se-dialog-content {
  padding: 4px 4px 45px 4px;

  .dialog {
    &-title {
      color: var(--grayscale-text-gray-333333, #333);
      font-feature-settings:
        "clig" off,
        "liga" off;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 25px;
      margin: 0 0 8px 0;
      display: flex;
      justify-content: space-between;
    }

    &product-id {
      color: #626469;
      font-feature-settings:
        "clig" off,
        "liga" off;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin: 0;
    }

    &__divider {
      margin: 20px 0;
    }

    &-files-title {
      color: var(--grayscale-light-gray-9-fa-0-a-4, #9fa0a4);
      font-feature-settings:
        "clig" off,
        "liga" off;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 30px;
      margin: 0;
    }

    &-table-file-name,
    &-table-extension {
      color: #333;
      word-break: break-all;
    }

    &-table-link {
      a {
        color: var(--brand-colors-sky-blue-depreciated, #42b4e6);
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }

    &-table-download-all {
      border: none;
    }

    &-table-download-all-files {
      padding: 12px 0 0 12px;
      a {
        color: var(--brand-colors-sky-blue-depreciated, #42b4e6);
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }

    &-close-button {
      cursor: pointer;
    }
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin-top: 20px;
  }

  th {
    text-align: left;
    color: #626469;
    font-feature-settings:
      "clig" off,
      "liga" off;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    padding-left: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e7e6e6;
  }

  tr {
    border-bottom: 1px solid #ddd;
  }

  td {
    text-align: left;
    padding: 12px 0 12px 12px;
    font-feature-settings:
      "clig" off,
      "liga" off;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
}
.private-doc-premium-tag {
  margin-bottom: 5px;
}

.product-result-card {
  &__text-content-section {
    &--top {
      &.private-doc {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: flex-start;
      }
    }
  }
}
